/**
 * draftRecovery — EMAILS-IMPL-015
 *
 * Lightweight, non-authoritative refresh/accidental-loss protection for
 * unsaved Email Builder edits (§37). Deliberately NOT governed data and
 * NOT a server-side mutable Builder draft (§36) -- purely a per-viewer
 * browser-storage convenience, exactly this repo's own established
 * localStorage posture. Keyed by Creative ID + the BASE Version the draft
 * started from, so a recovered draft is only ever offered against the
 * same starting point it was made from -- never silently applied over a
 * newer server Version (§37).
 */

const PREFIX = "missionassist:email-builder-draft";

function storageKey(creativeId, baseVersion) {
  return `${PREFIX}:${creativeId}:${baseVersion || "none"}`;
}

export function saveDraftToStorage(creativeId, baseVersion, draft) {
  try {
    window.localStorage.setItem(storageKey(creativeId, baseVersion), JSON.stringify({ draft, savedAt: new Date().toISOString() }));
  } catch {
    // Best-effort only -- a private window, cleared site data, or a
    // storage-blocking browser must never break the Builder itself.
  }
}

export function loadDraftFromStorage(creativeId, baseVersion) {
  try {
    const raw = window.localStorage.getItem(storageKey(creativeId, baseVersion));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.draft || null;
  } catch {
    return null;
  }
}

export function clearDraftFromStorage(creativeId, baseVersion) {
  try {
    window.localStorage.removeItem(storageKey(creativeId, baseVersion));
  } catch {
    // Best-effort only -- see saveDraftToStorage.
  }
}
